import $ from 'jquery';
import Cookies from 'js-cookie';

export default class FontSize {

    init() {
        // $(window).on('load', () => {
        //     this.fontSizeChange();
        // })

        let cookies = Cookies.get('fontSize');

        let elm = $('html');
        //変数が空ならfontSを、空でなければクッキーに保存しておいたものを適用

        if (!Cookies.get('fontSize')) {
            elm.addClass('js-link');
            $('#fzS').addClass('is-active');
        } else {
            elm.addClass(cookies);
            $('#fzS').removeClass('is-active');
            $('#' + cookies).addClass('is-active');
        }

        //ボタンをクリックしたら実行
        $('.js-fontSize').click(function () {
            //is-activeでないボタンだった場合のみ動作
            if (!$(this).hasClass('is-active')) {
                //現在is-activeのついているclassを削除
                $('.is-active').removeClass('is-active');
                //クリックしたボタンをis-active
                $(this).addClass('is-active');
                //クリックした要素のID名を変数にセット
                let setFontSize = this.id;
                //クッキーに変数を保存
                Cookies.set('fontSize', setFontSize,{expires: 30});
                //一度classを除去して、変数をclassとして追加
                elm.removeClass().addClass(setFontSize);
            }
        });
    }

}
